import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class SlugantCorpse extends OrganicMobCorpse {
	static key = "SlugantCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): SlugantCorpse {
		const c = new SlugantCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
